import React from "react";
import { LinkIcon } from "@heroicons/react/20/solid";
const MagicLinkLogo = () => {
  return /*#__PURE__*/React.createElement(LinkIcon, null);
};
export { MagicLinkLogo };